import { Helmet } from 'react-helmet'
import { useSearchParams } from 'react-router'

import { SalesOwnerFilter } from '@/components/SalesOwnerFilter'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { TableSkeletonRows } from '@/components/ui/table-skeleton'
import { useRequoteRequests } from '@/models/requoteRequest'
import { RequoteRow } from './RequoteRow'

const COLUMN_COUNT = 7

/** Every customer who asked for a re-quote from their quotes page, newest request first. */
export function Requotes() {
  const [searchParams, setSearchParams] = useSearchParams()
  const salesOwner = searchParams.get('sales_owner') || ''
  const { rows, isLoading, isError } = useRequoteRequests(salesOwner)

  return (
    <>
      <Helmet>
        <title>Requotes</title>
      </Helmet>
      <div className="flex flex-col gap-5">
        <div className="mb-2 text-2xl font-semibold">Requotes</div>
        <SalesOwnerFilter
          value={salesOwner}
          onValueChange={(value) => setSearchParams(value === 'all' ? {} : { sales_owner: value })}
          className="w-full border-neutral-300 data-[size=default]:h-11 sm:w-[180px]"
        />
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="font-semibold">Customer</TableHead>
              <TableHead className="font-semibold">Requested by</TableHead>
              <TableHead className="font-semibold">Last requested</TableHead>
              <TableHead className="text-right font-semibold">Requests</TableHead>
              <TableHead className="font-semibold">Sales owner</TableHead>
              <TableHead className="font-semibold">Status</TableHead>
              <TableHead className="font-semibold">Changes</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading && <TableSkeletonRows columns={COLUMN_COUNT} />}
            {isError && (
              <TableRow>
                <TableCell colSpan={COLUMN_COUNT} className="text-destructive py-6 text-center">
                  Couldn&rsquo;t load re-quote requests. Refresh to try again.
                </TableCell>
              </TableRow>
            )}
            {!isLoading && !isError && rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={COLUMN_COUNT} className="text-muted-foreground pt-5 text-center">
                  {salesOwner
                    ? 'No re-quote requests for this sales owner'
                    : 'No customer has asked for a re-quote yet'}
                </TableCell>
              </TableRow>
            )}
            {rows.map((row) => (
              <RequoteRow key={row.applicationId} row={row} />
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  )
}
